import {
    getCustomer,
    listCustomers
} from './queries';
import {
    createCustomer,
    deleteCustomer,
    updateCustomer,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    Customer,
    CreateCustomer,
    DeleteCustomer,
    GetCustomer,
    ListCustomers,
    UpdateCustomer
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {moduleConfig} from "../config";
import {ListRecordsQuery} from "../../../types";


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListCustomers>>(
            {
                query: listCustomers,
                variables: {
                    ...query
                },
            });

        return {
            items: response.data?.listCustomers.items,
            nextToken: response.data?.listCustomers.nextToken,
        };

    } catch (e: any) {
        console.trace(e);
        if (typeof e !== 'undefined' && typeof e.errors !== 'undefined') {
            const unauthorizedExceptionFound = e.errors.find((item: {
                errorType: string,
                message: string
            }) => item.errorType === 'UnauthorizedException')
            if (unauthorizedExceptionFound) {
                window.location.href = '/'
            }
        }
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetCustomer>>(
            {
                query: getCustomer,
                variables: {id: id},
            });
        return response.data?.getCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateCustomer>>(
            {
                query: createCustomer,
                variables: {input: payload},
            });
        console.debug('in the service response', response);
        notifySuccess(`${moduleConfig.titles.singular} created`)
        return response.data?.createCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Customer) => {

    console.debug('IN UPDATE', id, record);

    const {
        createdByUsername,
        createdByUser,
        created,
        updated,
        ...rest
    } = record

    try {
        const response = await client.graphql<GraphQLQuery<UpdateCustomer>>(
            {
                query: (updateCustomer),
                variables: {input: rest},
            });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteCustomer>>(
            {
                query: (deleteCustomer),
                variables: {input: {id: id}},

            });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteCustomer;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
